import styled from 'styled-components';

export const StyledSectionIntro = styled.div`
  margin: 0 auto;
  max-width: ${props => props.maxWidth || 870}px;
  padding: ${props => props.theme.spacing(0, 5)};
  text-align: center;
`;

export const Header = styled.h2`
  ${props => props.theme.typography.subheading1}
  margin-bottom: 0.5em;
  text-transform: uppercase;
`;

export const Subheader = styled.p`
  ${props => props.theme.typography.heading3}
  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.heading2}
  }
`;
